import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type {
  ProductProviderMappingDto,
  ProductProviderMappingFilter,
} from "@/features/ledger/api/dto";

/** Associations code produit / provider paginées (`POST /ProductProviderMappings/all`, guide §4.2). */
export const useProductProviderMappings = (
  params: ListRequest<ProductProviderMappingFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_PRODUCT_PROVIDER_MAPPINGS_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.productProviderMappings.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ProductProviderMappingDto>>,
    enabled,
  });
